import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://2505060961b10835c067f1c053bc64c4@o4511130684096512.ingest.us.sentry.io/4511130686586880',
  sendDefaultPii: true,
});
